import Vue from 'vue'
import Router from 'vue-router'
import Component from 'vue-class-component'

import routes from './routes'

Vue.use(Router)

Component.registerHooks(['beforeRouteEnter', 'beforeRouteLeave', 'beforeRouteUpdate'])

export default new Router({
  mode: 'history',
  base: '',
  routes
})
